<template>
    <el-container class="home-page-jl">
        <el-header class="my-el-header" style="height: 78px!important;">
          <div class="title">
            <img src="../../../static/image/plat-title33.png" style="height: 78px; width: auto; contain: inherit;cursor: pointer;" @click.stop="logout"/>
<!--            <div class="c-title">河北省计量业务应用平台</div>-->
          </div>

            <div class="btnBox" v-if="!notLogin">
                <span>
                      <span class="el-dropdown-link" style="margin-left: 9px;" >
                          欢迎您,
                          <span :title="userData.organizationName" v-if="userData && userData.organizationId && userData.type != '3'">{{userData.organizationName?userData.organizationName:""}} </span>
                          <template v-if="userData && userData.type===0 ">系统管理员</template>
                          <template v-if="userData && userData.type===1 ">单位管理员</template>
                           <template v-if="userData && userData.type===2 ">一般用户</template>
                          <template v-if="userData && userData.type===3 ">注册用户 </template>
                          <template v-if=" userData && userData.type!==0">
                              <el-upload
                                      class="avatar-uploader"
                                      accept=".jpg,.png"
                                      :limit="1"
                                      :action="baseUrl+'/file/upload'"
                                      :data="{category: 'user/avatar'}"
                                      :headers="headers"
                                      :show-file-list="false"
                                      :on-success="handleAvatarSuccess"
                                      :before-upload="beforeAvatarUpload">
                                  <el-avatar v-if="!userData.avatar" :src="require('../../../static/image/common/userImg.png')" class="avatar"></el-avatar>
                                  <el-avatar v-else :src="imageUrl+userData.avatar" class="avatar" fit="scale-down"></el-avatar>
                            </el-upload>
                          </template>

                          <span v-if="userData && (userData.type!==0 && userData.type!==1)">{{userData.name?userData.name:""}}</span>
                      </span>
                </span>

              <el-link icon="el-icon-switch-button" :underline="false" @click="logout2" title="退出登录" class="logoutBtn"></el-link>
            </div>
        </el-header>
        <el-container>
            <el-aside class="my-el-aside" :width="isCollapse?'66px':'252px'" :style="{backgroundColor:isCollapse?'#0294d7':''}" v-if="showMenu">
                <div class="menuTitleBox">
                    <div class="menuTitle menuTitle1" @click="logout()">平台首页</div>
                    <div class="menuTitle menuTitle2">{{menuName}}</div>
                </div>
                <el-menu :default-active="$route.path"
                         :collapse="isCollapse"
                         :router="false"
                         :unique-opened="false"
                         :collapse-transition="false"
                         class="menuBox"
                         active-text-color="#fff"
                         v-if="menus">
                    <SmarteduMenuItem :level="0" :key="menuItem.id" :menu="menuItem" v-for="menuItem in menus"></SmarteduMenuItem>
                </el-menu>
                <!--右下角-->
<!--                <div class="asideBottomBtn" @click="isCollapse = !isCollapse">-->
<!--                    <i :style="{color:isCollapse?'#fff':''}" :class="isCollapse?'el-icon-s-unfold':'el-icon-s-fold'"></i>-->
<!--                </div>-->
            </el-aside>

              <div class="my-el-container" :class="backWhite?'backWhite':''" :style="{left:showMenu?(isCollapse?'66px':'251px'):'0'}">
                <div class="fixed-header">
                  <tags-view v-if="menus" :module-id="moduleId"></tags-view>
                </div>
                <el-main>
                  <transition name="fade-transform" mode="out-in">
<!--                    <keep-alive :include="cachedViews">-->
<!--                  <router-view :key="key" class="main-content"/>-->
<!--                    </keep-alive>-->
                      <keep-alive>
                          <router-view v-if="$route.meta.keepAlive" :key="key" class="main-content"/>
                      </keep-alive>
                  </transition>
                    <transition name="fade-transform" mode="out-in">
                        <router-view v-if="!$route.meta.keepAlive" :key="key" class="main-content"/>
                    </transition>
<!--                    {{cachedViews}}-->
                </el-main>
              </div>
        </el-container>


        <!--修改密码-->
        <el-dialog v-dialogDrag title="修改密码"
                   :close-on-click-modal="false"
                   :visible.sync="changePwdDialog"
                   width="30%">
            <el-form ref="changePwdForm" :model="changePwdForm" :rules="rules" label-width="80px" style="margin-right: 20px;">
                <el-form-item label="旧密码" prop="oldPwd">
                    <el-input v-model="changePwdForm.oldPwd" show-password></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="newPwd">
                    <el-input v-model="changePwdForm.newPwd" show-password></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="newPwd2">
                    <el-input v-model="changePwdForm.newPwd2" show-password></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="changePwdDialog = false">取 消</el-button>
                <el-button type="primary" @click="changePwd('changePwdForm')" v-loading="changePwdLoading">确 定</el-button>
            </span>
        </el-dialog>

    </el-container>
</template>

<script>
    import {mapMutations} from "vuex";
    import SmarteduMenuItem from "@/components/SmarteduMenuItem";
    import baseUrl,{imageUrl} from "../../constants";
    // import imageUtils from "../../common/images";
    import store from "../../store";
    import {menuApi, moduleApi, userApi} from "../../api/organization";
    import TagsView from '@/components/tagsView'
    import {TagsViewModule} from "@/store/modules/tagsView";

    export default {
        name: 'Home',
        components: {
          TagsView,
            SmarteduMenuItem
        },
        data() {
            const validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else if(value.length < 6 || value.length > 16){
                    callback(new Error('长度在 6 到 16 个字符'));
                } else {
                    if (this.changePwdForm.newPwd !== '') {
                        this.$refs.changePwdForm.validateField('newPwd2');
                    }
                    callback();
                }
            };
            const validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if(value.length < 6 || value.length > 16){
                    callback(new Error('长度在 6 到 16 个字符'));
                } else if (value !== this.changePwdForm.newPwd) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                image:'',
                isCollapse: false,
                menus: null,
                flatMenus: null,  //拍扁的菜单
                userData:{},
                baseUrl:baseUrl,
                imageUrl:imageUrl,
                headers: {Authorization:""},
                teacher: this.$store.state.AuthedTeacher,
                currentSubject: this.$store.state.CurrentSubject,
                avatarImageUrl:"",
                changePwdDialog: false,  //修改密码弹框
                changePwdForm:{
                    oldPwd: "",
                    newPwd: "",
                    newPwd2: "",
                },
                changePwdLoading:false,  //修改密码覆盖
                rules: {
                    newPwd: [
                        { required: true, message: '请输入新密码', trigger: 'blur' },
                        { validator: validatePass, trigger: 'blur' }
                    ],
                    newPwd2: [
                        { required: true, message: '请输入确认密码', trigger: 'blur' },
                        { validator: validatePass2, trigger: 'blur' }
                    ],
                    oldPwd: [
                        { required: true, message: '请输入旧密码', trigger: 'blur' },
                        { min: 3, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }
                    ]
                },
                importedDialog: false,  //检测基础信息弹窗
                detectImp: false,  //是否勾选不再提示框
                routeName: "",  //路由name

                showMenu: false,
                menuName: "",
                moduleId: 0,
                oldPathName: "",
                oldRoute: null,


                // 被激活的连接地址
                activePath: '',
                activeTab: '1', //默认显示的tab
                tabIndex: 1, //tab目前显示数
                tabsItem: [],
                tabsPath: [],

                notLogin: false,   //是否未登录
                backWhite: false,
            }
        },
        created() {
            this.judgeRoute();
            // if (this.menus == null) {
                this.loadUser();
            // }
            // this.$root.$on('changeTabs', (e) => {
            //     this.addPage(e);
            // })
          this.$root.$off("closeTabs");
            this.$root.$on('closeTabs', (e) => {
                // this.$router.back();
                // console.log(TagsViewModule.visitedViews)
                // console.log(this.cachedViews)
              const tag = TagsViewModule.visitedViews.find(v => v.active);
              if(tag && tag.history.length > 0){
                const last = tag.history.pop();
                TagsViewModule.delCachedView(last)
                tag.path = last.path;
              } else {
                this.$router.back();
              }
                // const obj = this.tabsPath.find(e2=>e2.path == e);
                // if(obj){
                //     if(obj.oldFullPath){
                //         const oldArr = obj.oldFullPath.split(",");
                //         const lastOld = oldArr[oldArr.length - 1];
                //         obj.fullPath = lastOld;
                //         obj.path = lastOld.split("?")[0];
                //         oldArr.splice(oldArr.length - 1,1);
                //         obj.oldFullPath = oldArr.join(",");
                //         this.tabClick(obj);
                //     }else{
                //         this.removeTab(obj.name,1);
                //     }
                // }
            })
        },
        computed: {
          cachedViews() {
            const views = [...this.$store.state.tagsView.cachedViews];
            console.log("computed", views)
            views.push("EmptyIndex");
            return views
          },
          key() {
            return this.$route.fullPath
          }
        },
        methods: {
            ...mapMutations(["changeLogin","signout","pushMenu","updateCurrentSubject"]),
            //关闭tab  type == 1为在页面内触发
            removeTab(targetName,type) { //删除Tab
                let tabs = this.tabsItem; //当前显示的tab数组
                let activeName = this.activeTab; //点前活跃的tab

                //如果当前tab正活跃 被删除时执行
                if (activeName === targetName) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === targetName) {
                            let nextTab = tabs[index + 1] || tabs[index - 1];
                            if(type == 1 && this.oldRoute){
                                const obj = this.tabsPath.find(e=>e.path == this.oldRoute.path);
                                if(obj){
                                    const name = this.tabsPath.find(e=>e.path == this.oldRoute.path).name;
                                    nextTab = tabs.find(e=>e.name == name);
                                }
                            }
                            if (nextTab) {
                                activeName = nextTab.name;
                                this.tabClick(nextTab)
                            }
                        }
                    });
                }
                this.activeTab = activeName;
                this.tabsItem = tabs.filter(tab => tab.name !== targetName);
                //在tabsPath中删除当前被删除tab的path
                this.tabsPath = this.tabsPath.filter(item => item.name !== targetName)
            },
            tabClick(thisTab) {
                /*
                * thisTab:当前选中的tabs的实例
                * 通过当前选中tabs的实例获得当前实例的path 重新定位路由
                * */
                let val = this.tabsPath.filter(item => thisTab.name == item.name)
                const url = this.$route.fullPath;
                if(url == val[0].fullPath) return;
                this.$router.push({
                    path: val[0].fullPath
                })
            },


            changeSubject(s){
                this.updateCurrentSubject(s);
                this.currentSubject = s;
                this.$router.go(0);
            },
            loadUser(){
                const val = this.$route;
                if(['register-user', 'change-mechanism-select', 'change-mechanism-index', 'register-company-select', 'register-company', 'register-company-v2', 'change-mobile'].indexOf(val.name) > -1){
                    this.notLogin = true;
                    return
                }else{
                    this.notLogin = false;
                }
                userApi.getUserDetail().then(e=>{
                    sessionStorage.setItem('AuthedUser', JSON.stringify(e.data.data));
                    store.state.AuthedUser = e.data.data;
                    this.userData = this.$store.state.AuthedUser;
                    if(this.userData){
                        this.avatarImageUrl = this.userData.avatar;
                        this.headers.Authorization = this.$store.state.Authorization;
                    }
                });
                // else{
                //     this.logout3();
                // }
            },
            logout() {
                TagsViewModule.delAllViews();
                TagsViewModule.delAllCachedViews();
                location.href = '/list';
            },
            logout2() {
                this.$confirm('确定退出登录吗？', '退出登录', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.logout3();
                }).catch(() => {
                    console.log("取消")
                });
            },
            logout3(){
                TagsViewModule.clearViews();
                this.signout();
                this.$router.push("/login");
            },
            //修改密码调用接口
            changePwd(formName) {
                if(this.changePwdLoading){return;}
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        this.changePwdLoading = true;
                        this.$axios.post("/org-service/sso/changePassword", this.changePwdForm)
                            .then(response => {
                                if (response.data.result === 0) {
                                    this.$message({
                                        type: "success",
                                        message: response.data.message
                                    });
                                    this.changePwdDialog = false;
                                } else {
                                    this.$message({
                                        type: "error",
                                        message: "失败:" + response.data.message
                                    });
                                }
                                this.changePwdLoading = false;
                            })
                            .catch(error => {
                                this.changePwdLoading = false;
                                // 请求失败
                                this.$message({
                                    type: "error",
                                    message: "失败，连接服务器异常"
                                });
                            });
                    }
                })
            },
            //上传头像监控
            handleAvatarSuccess(res, file) {
                if(res.result === 0){
                    //保存用户头像
                    userApi.updateAvatar(res.data)
                        .then(r => {
                            if(r.data.result === 0){
                                this.userData.avatar = res.data;
                                sessionStorage.setItem('AuthedUser', JSON.stringify(this.userData));
                                this.$message.success("上传头像成功");
                            }
                        })
                }
            },
            //上传头像监控
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const isPNG = file.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG && !isPNG) {
                    this.$message.error('上传头像图片只能是 JPG 或 PNG格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return (isJPG||isPNG) && isLt2M;
            },
            //获取菜单
            getMenu(moduleId){
                this.moduleId = moduleId
                //type: sessionStorage.getItem("menuType")
                //, token: store.state.token
                userApi.menus({moduleId: moduleId}).then(r=>{
                    const rData = r.data.data;
                    var flatMenus = [];
                    flat(rData);
                    function flat(arr){
                        for(const d of arr){
                            if(d.children.length > 0){
                                flat(d.children)
                            }else{
                                flatMenus.push(d);
                            }
                        }
                    }
                    this.flatMenus = flatMenus;
                    this.flatMenus.push({
                      id: 0,
                      name: '我的主页',
                      url: '/home/' + this.moduleId,
                      moduleId: this.moduleId,
                      affix: true,
                      children: []
                    });
                    this.pushMenu({
                      moduleId: moduleId,
                      menus: flatMenus
                    });
                    this.menus = rData;
                    console.log(JSON.parse(JSON.stringify(this.flatMenus)))
                    this.routerPush();
                })
            },
            routerPush(){
                let path = "";
                let title = "";
                if(this.flatMenus){
                    // path = this.flatMenus[0].url;
                    // title = this.flatMenus[0].name;
                    path = "/homepage";
                    title = "主页";
                }
                const url = this.$route.path;
                if(path && path != url && this.oldPathName == "" && this.$route.path == '/page'){
                    this.$router.push(path);
                }
                if(this.tabsItem.length == 0){
                    this.tabsItem.push({
                        title: title,
                        name: '1',
                        closable: false,
                        ref: 'tabs',
                    })
                    this.tabsPath.push({
                        name: "1",
                        path: path,
                        fullPath: path,
                        oldFullPath: "",
                    })
                    this.$nextTick(()=>{
                        if(path != this.$route.path && this.$route.path != '/page'){
                            this.addPage({
                                meta:{
                                    title: this.$route.meta.title
                                },
                                path: this.$route.path,
                                fullPath: this.$route.fullPath
                            })
                        }
                    })
                }
            },
            judgeRoute(){
                const val = this.$route;
                if(['pageIndex', 'register-user', 'change-mechanism-select', 'change-mechanism-index', 'register-company-select', 'register-company', 'register-company-v2', 'change-mobile'].indexOf(val.name) > -1){
                    this.showMenu = false;
                    this.backWhite = true;
                    this.menus = null;
                    sessionStorage.setItem('menuName', "");
                }else{
                    this.showMenu = true;
                    this.backWhite = false;
                    if(val.meta && val.meta.moduleId){
                      this.moduleId = val.meta.moduleId;
                    } else {
                      const rootPath = '/' + val.fullPath.split('/')[1];
                      // console.log("path compare", rootPath)
                      this.moduleId = this.$router.getRoutes().find(r => r.path === rootPath).meta.moduleId;
                    }
                    const moduleId = this.moduleId;
                    if(this.menus == null){
                        this.getMenu(moduleId);
                        this.getModule(moduleId);
                    }else if(val.name == "jump"){
                        this.routerPush();
                    }
                }
            },
            getModule(moduleId){
                moduleApi.getOne({id: moduleId}).then(r => {
                    if(r.data.result === 0){
                        this.menuName = r.data.data.name;
                    }
                });
            },
            addPage(to){
                let flag = true //判断是否需要新增页面
                const path = to.path;
                const fullPath = to.fullPath;
                const fileName1 = path.split("/")[1];
                const fileName2 = path.split("/")[2]; //需要非数字，是数字说明是参数
                //如果目标文件夹存在于已开文件夹中，直接覆盖并更新old字段
                for(const e of this.tabsPath){
                    if(this.activeTab == e.name){
                        const eFile1 = e.path.split("/")[1];
                        const eFile2 = e.path.split("/")[2];
                        if(eFile1 == fileName1 && eFile2 != fileName2 && isNaN(fileName2)){
                            add(e);
                            return
                        }
                        //特殊：从人员管理进入人员信息页
                        if(eFile1 == "personList" && fileName1 == "userData"){
                            add(e);
                            return
                        }
                        //特殊：从单位管理进入证书
                        if(eFile1 == "mechanism" && fileName1 == "authorizeCert"){
                            add(e);
                            return
                        }
                    }
                }
                function add(e){
                    if(!e.oldFullPath){
                        e.oldFullPath = e.fullPath;
                    }else{
                        e.oldFullPath += ("," + e.fullPath);
                    }
                    e.path = path;
                    e.fullPath = fullPath;
                }

                let title = "";
                if(this.flatMenus){
                    const obj = this.flatMenus.find(e=>e.url==path);
                    if(obj){
                        title = obj.name;
                    }else{
                        title = to.meta.title;
                    }
                }
                if (Object.keys(to.meta).length != 0) {
                    for(let i = 0;i < this.tabsPath.length;i++){
                        const thisT = this.tabsPath[i];
                        if(thisT.path == path){
                            //更新fullpath
                            thisT.fullPath = fullPath;
                            this.activeTab = thisT.name;
                            flag = false;
                            break;
                        }
                        let oldArr = [];
                        if(thisT.oldFullPath){
                            oldArr = thisT.oldFullPath.split(",");
                            for(const o of oldArr){
                                if(o.split("?")[0] == path){
                                    //更新fullpath
                                    thisT.path = path;
                                    thisT.fullPath = fullPath;
                                    this.activeTab = thisT.name;
                                    thisT.oldFullPath = "";
                                    flag = false;
                                    break;
                                }
                            }
                        }
                    }
                    //使用title判断，会导致不同的详情打开同一个页面
                    // for (let i = 0; i < this.$refs.tabs.length; i++) {
                    //     // if (i != 0) { //首页不判断 如果页面已存在，则直接定位当页面，否则新增tab页面
                    //     if (this.$refs.tabs[i].label == title) {
                    //         this.activeTab = this.$refs.tabs[i].name  //定位到已打开页面
                    //         flag = false
                    //         break
                    //     }
                    //     // }
                    // }
                    //新增页面
                    if (flag) {
                        //获得路由元数据的name和组件名
                        const thisName = title
                        const thisComp = to.meta.comp
                        //对tabs的当前激活下标和tabs数量进行自加
                        let newActiveIndex = ++this.tabIndex + ''
                        //动态双向追加tabs
                        this.tabsItem.push({
                            title: thisName,
                            name: String(newActiveIndex),
                            closable: true,
                            ref: 'tabs',
                            content: thisComp
                        })
                        this.activeTab = newActiveIndex
                        /*
                        * 当添加tabs的时候，把当前tabs的name作为key，path作为value存入tabsPath数组中
                        * key:tabs的name
                        * value:tabs的path
                        * {
                        *   key: name,
                        *   value: path
                        * }
                        * ///后面需要得到当前tabs的时候可以通过当前tabs的name获得path
                        * */
                        if (this.tabsPath.indexOf(path) == -1) {
                            this.tabsPath.push({
                                name: newActiveIndex,
                                path: path,
                                fullPath: fullPath
                            })
                        }
                    }
                }
            }
        },
        // watch:{
        //     $route:{
        //         handler(val,oldval){
        //             this.oldPathName = oldval.name;
        //             this.judgeRoute();
        //         },
        //         // 深度观察监听
        //         deep: true
        //     }
        // }
        watch: {
            '$route': function (to,oldval) {  //监听路由的变化，动态生成tabs
                this.oldPathName = oldval.name;
                this.oldRoute = oldval;
                this.judgeRoute();
                this.addPage(to);
            }
        }
    }
</script>
<style lang="scss">
.home-page-jl{

  .fixed-header {
    position: fixed;
    top: 78px;
    right: 0;
    z-index: 9;
    transition: width 0.28s;
    width: calc(100% - 252px);
    .tags-view-container .tags-view-wrapper .tags-view-item.active{
      background-color: #087dba;
      color: #fff;
      border-color: #087dba;
    }
  }
  .importedDialog{
    .el-dialog__body{
      padding: 0 35px;
      margin: 0;
    }
  }
  .my-el-aside {
    display: block;
    position: absolute;
    left: 0;
    top: 78px;
    bottom: 0;
    overflow-y: hidden;
    /*width:200px !important;*/
    /*box-shadow: 8px 0px 15px #eee;*/
    overflow-x: hidden;

    .menuTitleBox{
      padding-top: 2px;
      .menuTitle{
        display: inline-block;
        width: 50%;
        text-align: center;
        line-height: 32px;
        color: #fff;
      }
      .menuTitle1{
        background-color: #0294d7;
        cursor: pointer;
      }
      .menuTitle2{
        background-color: #087dba;
      }
    }


    .asideBottomBtn {
      cursor: pointer;
      position: absolute;
      right: 20px;
      bottom: 9px;

      i {
        font-size: 25px;
        color: #fff;
      }
    }

    .el-submenu__title,
    .el-menu-item{
      height: 30px;
      line-height: 30px;
      color: #fff;
    }

    .el-menu-item:focus,
    .el-menu-item:hover {
      background-color: #087dba;
    }

    .el-menu {
      background-color: #229fda!important;
      color: #fff;
    }

    .el-menu i.iconfont{
      margin-right:10px;
    }

    .menuBox {
      overflow: auto;
      height: calc(100% - 34px);
      border: none;
      overflow-x: hidden;
      border-bottom: 1px solid #eee;
      margin-top: 2px;

      &::-webkit-scrollbar { /*滚动条整体样式*/
        width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 6px;
      }

      &::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #c1c1c1;
      }

      &::-webkit-scrollbar-track { /*滚动条里面轨道*/
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        background: #EDEDED;
      }
    }

    /*收起后样式*/
    .el-menu--collapse {
      background-color: transparent;

      .el-icon-setting {
        color: #fff;
      }

      .el-submenu {
        margin: 30px 0;
        .el-submenu__title{
          i.iconfont{
            font-size: 24px;
            color: #fff;
          }
        }
        &:hover{
          .el-submenu__title{
            i.iconfont {
              color: #67c23a!important;
            }
          }
        }

      }
      .is-active > .el-submenu__title {
        margin: 0 !important;
      }

      .is-active .el-submenu__title {
        background-color: #fff;
        border-radius: 50%;
        width: 40px;
        margin-left: 13px !important;
        padding-left: 8px !important;

        i.iconfont {
          color: #67c23a!important;
          /*62ae1d*/
        }
      }
    }
  }

  /*必须在外面*/
  .el-submenu__title:hover {
    background-color: #087dba;
  }
  .el-submenu__title {
    color: #fff;
    i {
      color: #fff;
    }
  }

  .my-el-container {
    display: block;
    position: absolute;
    top: 78px;
    right: 0;
    bottom: 0;
    overflow: auto;
    background-color: #889aa4;
  }
  .backWhite{
    background-color: #edf2f5;
    /*background-image: url("../../../static/image/indexbg.jpg");*/
  }

  /*头部*/
  .my-el-header {
    width: 100%;
    padding: 0 28px 0 0px;
    height: 78px;
    position: relative;
    background-image: url("../../../static/image/background-image.png");
    background-size: cover; /* 确保图片覆盖整个元素 */
    background-position: center; /* 将图片居中显示 */
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
    box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
    color: #fff;
    .title{
      margin-left: 0px;
      height: 78px;
      font-family: 'HarmonyOS_SansSC', sans-serif;
      display: flex;
      align-items: center; /* 垂直居中对齐 */
      gap: 12px; /* 图片和文字之间的间距 */
    }
    .c-title{
      font-size: 36px;
    }
    > .btnBox {
      position: absolute;
      right: 0px;
      margin-right: 40px;
      height: 78px;
      display: flex;
      align-items: center; /* 垂直居中对齐 */
      gap: 12px; /* 图片和文字之间的间距 */
      .el-link {
        i {
          font-size: 18px;
          color: #fff;
        }

        span {
          margin-left: 5px;
          color: #fff;
        }
      }
      .logoutBtn{
        vertical-align: sub;
        i {
          font-size: 24px;
        }
      }
    }
    .avatar-uploader{
      display: inline-block;
    }
  }

  .avatar{
    vertical-align: middle;
    width: 35px;height: 35px;
    margin-right: 8px;margin-left: 15px;
    >img{
      float: right;
    }
  }
}
</style>
